import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <Breadcrumbs />
        <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200">
          <header className="mb-8 border-b border-gray-100 pb-6">
            <h1 className="text-3xl font-bold font-poppins text-gray-900 mb-2">Privacy Policy</h1>
            <p className="text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString()}</p>
          </header>
          
          <div className="prose prose-blue max-w-none text-gray-700 leading-relaxed space-y-6">
            <p>
              Welcome to ChargesDecoder. We respect your privacy and are committed to protecting it. 
              This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
            </p>
            
            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">1. Information We Collect</h2>
                <p className="mb-3">
                    We prioritize your anonymity. We do not collect personally identifiable information (PII) such as your name, 
                    address, phone number, or bank account details unless you voluntarily provide them to us via email contact.
                </p>
                <ul className="list-disc pl-5 space-y-2">
                    <li>
                        <strong>Local Storage Data:</strong> We store small amounts of data locally on your device (in your browser's "Local Storage") 
                        to improve your experience. This includes your <strong>Selected Country</strong> preference and your <strong>API Key</strong> (only if you choose to enter one for development/testing). 
                        This data stays on your device and is not sent to our servers.
                    </li>
                    <li>
                        <strong>Usage Data:</strong> We may collect anonymous, aggregated usage data (such as pages visited, browser type, and time spent on the site) 
                        to help us understand how visitors use ChargesDecoder and to improve the service.
                    </li>
                </ul>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">2. Use of AI Services</h2>
                <p>
                    ChargesDecoder utilizes the <strong>Google Gemini API</strong> to provide AI-powered explanations for charge codes and search queries.
                </p>
                <ul className="list-disc pl-5 space-y-2">
                    <li>When you search for a charge or ask a question, the text of your query is sent to Google's servers to generate a response.</li>
                    <li>We do not send any personal identifiers associated with your query.</li>
                    <li><strong>Important:</strong> Please do not include sensitive personal financial information (such as full credit card numbers, passwords, or PINs) in your search queries.</li>
                </ul>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">3. Cookies</h2>
                <p>
                    We may use cookies to maintain your session preferences. You can choose to disable cookies through your browser settings, 
                    though this may affect your ability to use certain features of the website (like remembering your country selection).
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">4. Third-Party Links</h2>
                <p>
                    Our website contains links to third-party websites (such as official bank websites or payment apps). 
                    We are not responsible for the privacy practices or content of these third-party sites. We encourage you to read the privacy policies of any website you visit.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">5. Data Security</h2>
                <p>
                    We implement reasonable security measures to maintain the safety of your information. However, please be aware that no method of transmission over the Internet 
                    is 100% secure.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">6. Changes to This Policy</h2>
                <p>
                    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-3">7. Contact Us</h2>
                <p>
                    If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <a href="mailto:chargesdecoder@gmail.com" className="inline-block mt-2 text-primary font-semibold hover:underline">
                    chargesdecoder@gmail.com
                </a>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;